import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { AuthService } from 'projects/shared/src/lib/authentication/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

    canSeePieceRate: boolean = false;
    canSeePieceRateAdmin: boolean = false;

    private subscriptions: Subscription[] = [];

    constructor(private authService: AuthService) { }

    ngOnInit() {
        this.subscriptions = [
            this.authService.Roles.subscribe(roles => {
                const prRoles = [ 'scs site admin', 'scs admin', 'it', 'developers' ];
                const prAdminRoles = [ 'scs admin', 'it', 'developers', 'payroll' ];

                this.canSeePieceRate = roles.some(role => prRoles.indexOf(role) > -1);
                this.canSeePieceRateAdmin = roles.some(role => prAdminRoles.indexOf(role) > -1);
            })
        ];
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
